module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0NDggNTEyIj48cGF0aCBkPSJNMCA4NFY1NmMwLTEzLjMgMTAuNy0yNCAyNC0yNGgxMTJsOS40LTE4LjdjNC04LjIgMTIuMy0xMy4zIDIxLjQtMTMuM2gxMTQuM2M5LjEgMCAxNy40IDUuMSAyMS41IDEzLjNMMzEyIDMyaDExMmMxMy4zIDAgMjQgMTAuNyAyNCAyNHYyOGMwIDYuNi01LjQgMTItMTIgMTJIMTJDNS40IDk2IDAgOTAuNiAwIDg0em00MTUuMiA1Ni43TDM5NC44IDQ2N2MtMS42IDI1LjMtMjIuNiA0NS00Ny45IDQ1SDEwMS4xYy0yNS4zIDAtNDYuMy0xOS43LTQ3LjktNDVMMzIuOCAxNDAuN2MtLjQtNi45IDUuMS0xMi43IDEyLTEyLjdoMzU4LjVjNi44IDAgMTIuMyA1LjggMTEuOSAxMi43eiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/solid/trash.svg
// module id = XqNv
// module chunks = 1